// extracted by mini-css-extract-plugin
module.exports = {"card":"listticket_card__l4wbx"};